// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"b309cb17","195":"18c24ae0","247":"e6c1125f","267":"f2f5c711","408":"8901b8bb","488":"43e897b1","575":"44fcdffa","645":"cbb45806","962":"3e495db0"}[chunkId] + ".chunk.js";
};